export const  createFormData=(item)=>{
    var form_data = new FormData();

    for ( var key in item ) {
        form_data.append(key, item[key]);
    }
    return form_data
}
export function processAllTables(tableData) {
    // Validate input
    if (!tableData || !Array.isArray(tableData.tables)) {
        console.log("Invalid tableData:", tableData);
        return { folioDetails: [], total: { costValue: "0", marketValue: "0" } };
    }

    // Step 1: Flatten all tables into a single array
    const allRows = tableData.tables.flat();

    // Step 2: Process the rows
    const processedTable = [];
    let totalCostValue = 0;
    let totalMarketValue = 0;

    for (let i = 0; i < allRows.length; i++) {
        let row = allRows[i];

        // Skip invalid rows
        if (!row || typeof row["2"] !== "string") continue;

        // Skip header row
        if (row["0"] === "Folio No." && row["1"] === "ISIN") {
            // console.log("Skipping header row:", row);
            continue;
        }

        // Skip total row
        if (row["2"] === "Total") {
            // console.log("Skipping total row:", row);
            continue;
        }

        let schemeName = row["2"].trim();

        // Skip empty scheme names
        if (!schemeName) continue;

        // Step 3: Merge continuation rows where folioNo ("0") is empty
        while (i + 1 < allRows.length && allRows[i + 1]["0"] === "" && typeof allRows[i + 1]["2"] === "string") {
            schemeName += " " + allRows[i + 1]["2"].trim();
            i++; // Skip merged row
        }

        // Convert costValue and marketValue to numbers for summation
        let costValue = parseFloat(row["3"].replace(/,/g, "")) || 0;
        let marketValue = parseFloat(row["7"].replace(/,/g, "")) || 0;

        // Accumulate total costValue and marketValue
        totalCostValue += costValue;
        totalMarketValue += marketValue;


        // Step 4: Push to the processed array
        processedTable.push({
            folioNo: row["0"] || "",
            isin: row["1"] || "",
            schemeName: schemeName,
            costValue: costValue, // Format as readable number
            unitBalance: Number(row["4"]) || 0,
            navDate: row["5"] || "",
            nav: Number(row["6"]) || 0,
            marketValue:marketValue, // Format as readable number
            registrar: row["8"] || ""
        });
    }
       
        processedTable[processedTable.length-1].schemeName=processedTable[processedTable.length-1].schemeName.replace("Total","")
    // Return processed data with totals
    return {
        folioDetails: processedTable,
        total: {
            costValue: totalCostValue,
            marketValue: totalMarketValue
        }
    };
}
